// Educabolivia/src/components/HeroSection.js
import React, { useContext } from 'react';
import { AuthContext } from './AuthContext';

const HeroSection = ({ onStartNow, onViewCourses }) => {
  const { currentUser, isAuthenticated } = useContext(AuthContext);

  return (
    <section className="bg-white-700 text-black py-5">
      <div className="container mx-auto px-4">
        {isAuthenticated ? (
          <div>
            <h1 className="text-4xl font-bold mb-4">Bienvenido, {currentUser?.first_name || 'Usuario'}</h1>
            <p className="text-xl mb-8">Continúa tu aprendizaje hoy</p>
          </div>
        ) : (
          <div>
            <h1 className="text-4xl font-bold mb-4">Aprende sin límites</h1>
            <p className="text-xl mb-8">Empieza, cambia o impulsa tu carrera con cursos desde 25 Bs.</p>
          </div>
        )}
        <div className="flex flex-col sm:flex-row gap-4">
          {!isAuthenticated && (
            <button
              type="button"
              onClick={onStartNow}
              className="border border-black bg-blue text-black px-6 py-3 rounded font-bold hover:bg-green-600"
            >
              Empieza ahora
            </button>
          )}
          <button
            type="button"
            onClick={onViewCourses}
            className="border border-black text-black px-6 py-3 rounded font-bold hover:bg-green-600"
          >
            Ver cursos
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
